import {AnimatePresence, motion} from 'motion/react';
import {useId} from 'react';
import {getMotionProps} from '../../libs';

interface SidebarCountProps {
  value: number | undefined;
}

const countMotionProps = getMotionProps({
  initial: {x: 4, opacity: 0},
  animate: {x: 0, opacity: 1},
  exit: {x: 4, opacity: 0},
});

const digitMotionProps = getMotionProps({
  initial: {y: -4, opacity: 0},
  animate: {y: 0, opacity: 1},
  exit: {y: 4, opacity: 0},
});

export const SidebarCount = ({value}: SidebarCountProps) => {
  const id = useId();
  return (
    <AnimatePresence>
      {!!value && (
        <motion.div
          {...countMotionProps}
          className="ml-auto text-right text-text-secondary text-xs"
        >
          <AnimatePresence initial={false} mode="wait">
            <motion.div key={`count-${id}-${value}`} {...digitMotionProps}>
              {value}
            </motion.div>
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
